import { Button } from '@signate-cloud/ui-lib/src/components/atoms/Button';
import { useRouter } from 'next/compat/router';
import { HtmlHead } from '@/components/atoms/HtmlHead';
import { copyright } from '../pages';

export default function Custom404() {
  const router = useRouter();

  return (
    <>
      <HtmlHead title="404 NOT FOUND" />
      <div className="page-error-wrapper">
        <div>
          <h1 className="error-title">404</h1>
          <h5 className="tx-sm-24 tx-normal">
            お探しのページは見つかりません。
          </h5>
          <p className="mg-b-50">
            URLに間違いがあるか、ページが移動した可能性があります。
          </p>
          <p className="mg-b-50">
            <Button
              type="button"
              onClick={() => router?.back()}
              className="btn btn-error"
            >
              戻る
            </Button>
          </p>
          <p className="error-footer">{copyright}</p>
        </div>
      </div>
    </>
  );
}
